// @ts-nocheck
import React, { useState } from "react";

/**
 * Menu photo with a graceful placeholder.
 *
 * Not every item in the database carries a photo, and a broken <img> looks like a
 * bug. Where there is no usable image this renders a soft tile with an icon instead.
 */
const MenuImage = ({ src, alt, className = "", icon = "🍽️", onClick }) => {
    const [failed, setFailed] = useState(false);

    if (!src || failed) {
        return (
            <div
                onClick={onClick}
                className={`flex items-center justify-center bg-gradient-to-br from-slate-50 via-white to-indigo-50 ${className}`}
            >
                <span className="text-4xl opacity-40 select-none" role="img" aria-label={alt}>
                    {icon}
                </span>
            </div>
        );
    }

    return (
        <img
            src={src}
            alt={alt}
            className={className}
            onClick={onClick}
            onError={() => setFailed(true)}
            loading="lazy"
        />
    );
};

export default MenuImage;
